import type { JSX } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useCandidateProfile } from '../hooks/useCandidateProfile';
import { CandidateProfileHeading } from '../components/CandidateProfileHeading';
import { CandidateProfileWizard } from '../components/CandidateProfileWizard';
import { CandidateEducationSection } from '../components/CandidateEducationSection';

function ProfileLoadError({ message }: { message: string }): JSX.Element {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Error Loading Profile</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-destructive">{message}</p>
      </CardContent>
    </Card>
  );
}

export function CandidateDashboardPage(): JSX.Element {
  const { profile, isLoading, isError, error } = useCandidateProfile();

  if (isLoading) {
    return <div className="flex items-center justify-center p-6">Loading...</div>;
  }

  if (isError) {
    return <ProfileLoadError message={error?.message || 'Failed to load profile.'} />;
  }

  return (
    <div className="space-y-8">
      <CandidateProfileHeading name={profile?.name} email={profile?.email} />
      <CandidateProfileWizard />
      <section className="space-y-3" aria-labelledby="candidate-optional-details">
        <h2 id="candidate-optional-details" className="text-sm font-medium text-muted-foreground">
          Optional details — not part of the verification steps
        </h2>
        <CandidateEducationSection />
      </section>
    </div>
  );
}
